import { render } from "./TipsCustom.vue?vue&type=template&id=145c7c52"
import script from "./TipsCustom.vue?vue&type=script&lang=js"
export * from "./TipsCustom.vue?vue&type=script&lang=js"
script.render = render

export default script